import { Card, Input, Select } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { TRegistrationFormDataDE } from '../../../registration.types';
import styles from '../../../RegistrationForm.module.css';

type TProps = {
  disabled?: boolean;
};

export const AccountInformationDE = ({ disabled = false }: TProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<TRegistrationFormDataDE>();

  return (
    <>
      <h2>
        <Trans>Personal information</Trans>
      </h2>
      <Card className={styles.accountInformationContainer}>
        <div className={styles.formField}>
          <Select
            {...register('title')}
            label={t`Title`}
            id="title"
            type="text"
            disabled={disabled}
          >
            <option value="Herr">
              <Trans>Mr</Trans>
            </option>
            <option value="Frau">
              <Trans>Ms</Trans>
            </option>
          </Select>
        </div>
        <div className={styles.formField}>
          <Input
            {...register('firstName')}
            id="firstName"
            type="text"
            label={t`First name`}
            placeholder="Max"
            disabled={disabled}
            error={errors.firstName && errors.firstName.message}
          />
        </div>
        <div className={styles.formField}>
          <Input
            {...register('lastName')}
            id="lastName"
            type="text"
            label={t`Last name`}
            placeholder="Mustermann"
            disabled={disabled}
            error={errors.lastName && errors.lastName.message}
          />
        </div>
        <div className={clsx(styles.formField, styles.email)}>
          <Input
            {...register('email')}
            id="email"
            type="email"
            label={t`Email`}
            placeholder="ich@iwoca.de"
            disabled={disabled}
            error={errors.email && errors.email.message}
          />
        </div>
        <div className={styles.formField}>
          <Input
            {...register('phoneNumber')}
            id="phoneNumber"
            type="text"
            label={t`Phone number`}
            placeholder="+49 123456789"
            disabled={disabled}
            error={errors.phoneNumber && errors.phoneNumber.message}
          />
        </div>
      </Card>
    </>
  );
};
